import TextArea from "../UI/TextArea";

export default function OneHourHomeVisitInfo({
  register,
  setValue,
  errors,
}) {
  return (
    <div>
      <h2 className="text-3xl font-bold mb-14">One Hour Home Visit</h2>
      <div className="grid gap-12 grid-cols-1 md:grid-cols-2">
        <p>The One Hour Home Visit service includes a callout up to an hour long for tasks such as:</p>
        <div>
            <ul>
                <li className="list-disc ml-5 mb-2">Fault finding & rectification</li>
                <li className="list-disc ml-5 mb-2">Lighting installation</li>
                <li className="list-disc ml-5 mb-2">Kitchen appliance installation</li>
                <li className="list-disc ml-5 mb-2">Bathroom extractor fan installation</li>
                <li className="list-disc ml-5 mb-2">Replacement of electrical accessories</li>
            </ul>
        </div>
      </div>
      <div className="mt-8">
        <TextArea
          register={register}
          registerItem="customerNotes"
          type="text"
          label="What would you like us to do? (You can review and edit this in the next step)"
          placeholder="Please describe the work you need done..."
          required={true}
          minLength={50}
          validationMessage="Please describe the job in more detail"
          errors={errors}
        />
      </div>
    </div>
  );
}
